import { forwardRef, useId, type ComponentPropsWithoutRef, type ReactNode } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

type InputProps = {
    label?: string;
    labelIcon?: ReactNode;
    error?: string;
};

export const Input = forwardRef<HTMLInputElement, ComponentPropsWithoutRef<'input'> & InputProps>((props, ref) => {
    const { label, labelIcon, className, error, ...inputProps } = props;
    const generatedId = useId();

    inputProps.id ??= generatedId;
    const errorId = `${inputProps.id}-error`;
    const describedBy = [inputProps['aria-describedby'], error ? errorId : undefined].filter(Boolean).join(' ');

    return (
        <div className={classNames(styles.container, className)} data-validation-error={error ? 'true' : undefined}>
            <div className={classNames(styles['input-box'], { [styles.red]: !!error })}>
                <input
                    className={styles.input}
                    {...inputProps}
                    aria-invalid={!!error}
                    aria-describedby={describedBy || undefined}
                    placeholder={label}
                    ref={ref}
                ></input>
                <label className={styles.label} htmlFor={inputProps.id}>
                    {labelIcon}
                    {label}
                </label>
            </div>
            {error && (
                <span id={errorId} className={styles.error} role="alert">
                    {error}
                </span>
            )}
        </div>
    );
});
